export const misBuilderMenuDef = [
  {
    name: 'menu.oltp_to_mis',
    icon: 'fa fa-tag',
    resource: 'oltp_to_mis',
    url: 'oltp_to_mis',
    auto_crud: true
  },
  {
    name: 'menu.patient_journey',
    icon: 'fa fa-tag',
    resource: 'patient_journey',
    url: 'patient_journey',
    auto_crud: true
  },
  {
    name: 'menu.SAP_int',
    icon: 'fa fa-tag',
    resource: 'SAP_int',
    url: 'SAP_int',
    auto_crud: true
  },
  {
    name: 'menu.date_time_patient_journey',
    icon: 'fa fa-tag',
    resource: 'date_time_patient_journey',
    url: 'date_time_patient_journey',
    auto_crud: true
  },
  {
    name: 'menu.update_transaction_data',
    icon: 'fa fa-tag',
    resource: 'update_transaction_data',
    url: 'update_transaction_data',
    auto_crud: true
  },
  {
    name: 'menu.ex_finance_oltp',
    icon: 'fa fa-tag',
    resource: 'ex_finance_oltp',
    url: 'ex_finance_oltp',
    auto_crud: true
  },
  {
    name: 'menu.ex_finance_oltp_date_range',
    icon: 'fa fa-tag',
    resource: 'ex_finance_oltp_date_range',
    url: 'ex_finance_oltp_date_range',
    auto_crud: true
  },
  {
    name: 'menu.oltp_to_mis_config',
    icon: 'fa fa-tag',
    resource: 'oltp_to_mis_config',
    url: 'oltp_to_mis_config',
    auto_crud: true
  },
  {
    name: 'menu.add_oltp_to_mis',
    icon: 'fa fa-tag',
    resource: 'add_oltp_to_mis',
    url: 'add_oltp_to_mis',
    auto_crud: true
  },
  {
    name: 'menu.view_oltp_to_mis',
    icon: 'fa fa-tag',
    resource: 'view_oltp_to_mis',
    url: 'view_oltp_to_mis',
    auto_crud: true
  }
]